import type { Locale } from "@/lib/i18n";
import { pl, type CNewsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cNewsTranslations: Record<Locale, CNewsTranslations> = {
  pl,
  en,
  de,
};

export type { CNewsTranslations };
